export enum VersionSocketEventName {
  Refresh = 'refresh',
}
